/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { UserParameters } from "features/userParameters/UserParametersSchema"

interface UserParametersState {
  parameters: UserParameters | null
}

const initialState: UserParametersState = {
  parameters: null,
}

const resultsSlice = createSlice({
  name: "lastSubmittedParameters",
  initialState: initialState,
  reducers: {
    setLastSubmittedParameters: (state, action: PayloadAction<UserParameters>) => {
      state.parameters = action.payload
    },
  },
})

export const { setLastSubmittedParameters } = resultsSlice.actions
export default resultsSlice.reducer
